import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PanelSectionLoading } from '../../../core/components/styled';
import { Resolver } from '../../../core/components';
import { DocumentTitle } from '../../../common/components';
import { getQueryParams } from '../../../utils/services/queryParams';
import { SOLD } from '../../../quote/constants';
import { loadOpportunities } from '../../ducks';
import SoldOpportunitiesSection from './SoldOpportunitiesSection';

class SoldOpportunitiesSectionResolver extends PureComponent {
  resolve = () => {
    const {
      loadOpportunities,
      location: { search },
    } = this.props;
    const { page, limit, sortedBy, sortOrder } = getQueryParams(search);
    return loadOpportunities(SOLD, page, limit, sortedBy, sortOrder);
  };

  render() {
    return (
      <>
        <DocumentTitle>Sold Opportunities</DocumentTitle>
        <Resolver
          successComponent={SoldOpportunitiesSection}
          loadingComponent={PanelSectionLoading}
          resolve={this.resolve}
        />
      </>
    );
  }
}

SoldOpportunitiesSectionResolver.propTypes = {
  loadOpportunities: PropTypes.func.isRequired,
  location: RouterPropTypes.location.isRequired,
};

const mapDispatchToProps = { loadOpportunities };

export default withRouter(
  connect(
    undefined,
    mapDispatchToProps,
  )(SoldOpportunitiesSectionResolver),
);
